export default __webpack_public_path__ + "static/media/bg-pattern-hero-desktop.fdd40c2d.svg";